import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IGetAcompanhantesByAgendamentoResponse } from './acompanhante.model';

@Injectable({
  providedIn: 'root'
})
export class AcompanhanteService {
  constructor(private http: HttpClient) {}

  public GetAcompanhantesByAgendamentoId(
    fkAgnd: number
  ): Observable<IGetAcompanhantesByAgendamentoResponse> {
    const url = `${environment.baseURL}Acompanhante/GetAcompanhatesByAgendamentoId?FK_AGND=${fkAgnd}`;
    return this.http.get<IGetAcompanhantesByAgendamentoResponse>(url);
  }
}
